export default "__VITE_ASSET__12ae5f14__"